import React, { memo, useEffect } from 'react';
import { AllProductInventory, LowInventoryProducts, OutOfStockInventory } from '../product-types/ProductType';
import { ProductInventoryTabs } from '../productinventory.constants';

function getProductTab(currenTab, token, loggedIn) {
  const { allProducts, lowInventory, outofStock } = ProductInventoryTabs;
  switch (currenTab) {
    case allProducts:
      return <AllProductInventory token={token} loggedIn={loggedIn} />

    case lowInventory:
      return <LowInventoryProducts token={token} loggedIn={loggedIn} />

    case outofStock:
      return <OutOfStockInventory token={token} loggedIn={loggedIn} />

    default:
      return null;
  }
}

function ProductData(props) {
  const { currentTab, token, loggedIn } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentTab]);

  return (
    <div>
      {getProductTab(currentTab, token, loggedIn)}
    </div>
  )
}

export default memo(ProductData);